import { pagination_params } from '../../shared/utils/pagination_params';

export const getParamsUrl = (params) => {
  if (!params) return '';
  let path = '';
  path = pagination_params(params);
  params.FechaDesde && (path = `${path !== '' ? `${path}&` : ''}FechaDesde=${params.FechaDesde}`);
  params.FechaHasta && (path = `${path !== '' ? `${path}&` : ''}FechaHasta=${params.FechaHasta}`);
  params.CodigoVendedor !== null &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoVendedor=${params.CodigoVendedor}`);
  params.Cliente && (path = `${path !== '' ? `${path}&` : ''}Cliente=${params.Cliente}`);
  params.Referencia && (path = `${path !== '' ? `${path}&` : ''}Referencia=${params.Referencia}`);
  params.CodigoCotizacion &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoCotizacion=${encodeURIComponent(params.CodigoCotizacion)}`);
  params.CodigoEspecificacionTecnica &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEspecificacionTecnica=${encodeURIComponent(params.CodigoEspecificacionTecnica)}`);
  params.CodigoEquivalente &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEquivalente=${params.CodigoEquivalente}`);
  params.CodigoAdicional &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoAdicional=${params.CodigoAdicional}`);
  params.DescripcionComercial &&
    (path = `${path !== '' ? `${path}&` : ''}DescripcionComercial=${encodeURIComponent(params.DescripcionComercial)}`);
  params.CodigoUsabilidad &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoUsabilidad=${params.CodigoUsabilidad}`);
  params.CodigoPropuesta &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoPropuesta=${encodeURIComponent(params.CodigoPropuesta)}`);
  params.Estado &&
    params.Estado.Codigo &&
    (path = `${path !== '' ? `${path}&` : ''}CodigoEstado=${params.Estado.Codigo}`);
  return path;
};
